// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
    apiURL: 'http://localhost:56650',
/*  apiURL: 'https://api.point-s.pl',*/
  userType: 'Centrala',
  appName: 'AdministrationApp',
  oldAppURL: 'http://localhost:59711',
  menuPosition: 'side', // 'side', 'top', 'none'
  reconnectionTime: 15000, // try reconnect to web socket after reconnectionTime [ms]
  compactViewWidth: 1080, // if screen innerWidth < compactViewWidth -> some items of minidashboard will be hidden
  tooltipDelay: 250,
};
